export default __webpack_public_path__ + "static/media/americancampco.6934d540.jpg";